import React from 'react';

const CheckSmallIcon = () => (
  <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.2148 0.369015C10.505 0.1025 10.9798 0.0985144 11.2753 0.360207C11.5708 0.621962 11.5753 1.05022 11.2851 1.31678L4.41012 7.6305C4.26909 7.76 4.07621 7.83309 3.87496 7.83309C3.6737 7.83309 3.48082 7.76 3.3398 7.6305L0.214803 4.76078C-0.0754241 4.49424 -0.0709463 4.066 0.224568 3.80421C0.520089 3.54244 0.994878 3.54648 1.28512 3.81302L3.87398 6.19124L10.2148 0.369015Z" fill="white" fillOpacity="0.5"/>
  </svg>
);

export default CheckSmallIcon;
